const INITIAL_STATE = {
  screen: null,
  currentForm: '',
  submitForm: '',
  isProcessing: false,
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case 'CHANGE_SCREEN':
      return {
        ...state,
        submitForm: '',
        screen: payload.link,
        currentForm: payload.form || state.currentForm,
        isProcessing: false,
      };
    case 'SUBMIT_FORM':
      return {
        ...state,
        submitForm: payload,
      };
    case 'ENABLE_SPINNER':
      return {
        ...state,
        isProcessing: true,
      };
    case 'DISABLE_SPINNER':
      return {
        ...state,
        isProcessing: false,
      };
    case 'CANCEL_SUBMIT':
      return {
        ...state,
        submitForm: '',
      };
    default:
  }
  return state;
};
